import { Box, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import CommonUtil from "../../util/CommonUtils";
import { useTranslation } from "react-i18next";
import AppContext from "../../config/AppContext";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as CancelIcon } from "../../assets/images/ralvie/Close.svg";
import "../project/AddProject.scss";
import TagTextField from "./Tagtextfield";


export default function TagworkField(props) {
    const [helperText, setHelperText] = useState(props.helperText);
    const [error, setError] = useState(props.error);
    const { t } = useTranslation();
    const [isFocused, setIsFocused] = useState(false);
    const [placeholderText, setPlaceholderText] = useState(props.label);
    const { mode } = useContext(AppContext);

    useEffect(() => {
        setError(props.error);
        setHelperText(props.helperText);
    }, [props.error]);

    const handleChange = (e) => {
        let val = e.target.value;
        if (val.trim() === "") {
            val = val.trim();
        }
        if (e.target.value.length > 0 && val.length == 0) {
            return;
        }
        if (val.length > 2) {
            if (val[val.length - 1] === " " && val[val.length - 2] === " ") {
                return;
            }
            if (val[0] === " ") {
                return;
            }
        }
        if (props.validation) {
            switch (props.validation) {
                case "alpha-numeric":
                    handleAlphaNumeric(e);
                    break;
                case "numeric":
                    handleNumeric(e);
                    break;
                case "email":
                    handleEmail(e);
                    break;
                case "url":
                    handleUrl(e);
                    break;
                case "password":
                    handlePassword(e);
                    break;
                case "code":
                    handleCode(e);
                    break;
                case "mobile":
                    handleMobile(e);
                    break;
                case "postcode":
                    handlePostCode(e);
                    break;
                case "alpha-numeric-underscore":
                    handleCodeUnderscore(e);
                    break;
                case "alpha-numeric-space":
                    handleAlphaNumericSpace(e);
                    break;
                case "numericWithoutDot":
                    handleNumericWithoutDot(e);
                    break;
                default:
                    props.onChange(e);
            }
        } else {
            props.onChange(e);
        }
    };

    const handleAlphaNumeric = (e) => {
        if (CommonUtil.isAlphaNumericSpace(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0025"));
        }
    };

    const handleCodeUnderscore = (e) => {
        if (CommonUtil.isAlphaNumericUnderscore(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("Only accepts alphabets, numerics and underscore"));
        }
    };

    const handleAlphaNumericSpace = (e) => {
        if (CommonUtil.isAlphaNumericSpace(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(
                t("Only accepts alphabets, numerics, space and underscore")
            );
        }
    };
    const handleNumericWithoutDot = (e) => {
        if (CommonUtil.isValidPasitiveNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText("Only accepts numerics");
        }
    };

    const handleCode = (e) => {
        if (CommonUtil.isAlphaNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0023"));
        }
    };

    const handlePostCode = (e) => {
        if (CommonUtil.isValidCode(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0021"));
        }
    };

    const handleNumeric = (e) => {
        if (CommonUtil.isValidNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0024"));
        }
    };

    const handleEmail = (e) => {
        props.onChange(e);
        if (CommonUtil.isValidEmail(e.target.value)) {
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0022"));
        }
    };

    const handleUrl = (e) => {
        props.onChange(e);
        if (CommonUtil.isValidUrl(e.target.value)) {
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0029"));
        }
    };

    const handleMobile = (e) => {
        if (CommonUtil.isValidPasitiveNumeric(e.target.value)) {
            props.onChange(e);
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0024"));
        }
    };

    const handlePassword = (e) => {
        props.onChange(e);
        if (CommonUtil.isAlphaNumericPassword(e.target.value)) {
            setHelperText(props.helperText);
            setError(false);
        } else {
            setError(true);
            setHelperText(t("RAL0010"));
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
        if (props.label && !props.label?.includes("Search") && !props.label?.includes("Enter")) {
            setPlaceholderText(`${t("RAL0089")}${props.label.toLowerCase()}`);
        }
    };

    const handleBlur = () => {
        setIsFocused(false);
        setPlaceholderText(props.label);
    };

    return (
        <Box width={"100%"} display={"flex"} justifyContent={"space-between"}>
            <Box sx={{ flexGrow: 1 }}>  <TagTextField
                id="btn-edit-tag"
                name={props.name}
                label={t("RAL0194")}
                value={props.value}
                onChange={(e) => handleChange(e)}
                inputProps={{
                    maxLength: 20,
                }}
                fullWidth
            />
            </Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                    marginRight:"10px"
                }}
            >
                <CustomButton
                    id="btn-add-orgnization"
                    size="small"
                    variant="contained"
                    className="org-add-button"
                    onClick={props.onClick}
                    sx={{
                        padding: "4px 10px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                    }}
                    disabled={!props.value || props.value.trim().length === 0}
                >
                    {t("RAL0170")}
                </CustomButton>
                <IconButton
                    className="org-cancel-icon"
                    id="btn-org-name-cancel"
                    onClick={props.onCancelClick}
                >
                    <CancelIcon />
                </IconButton>
            </Box>
        </Box>
    );
}
